import { Modal } from '../../modules/modal.js';

window.app = window.app || {};
app.site = app.site || {};

app.site.misc = () => {
    const html = document.querySelector('html');
    const wrapper = document.getElementById('wrapper');
    const resizer = () => {
        html.classList.toggle('layout-bg-hide-02', wrapper.offsetHeight <= 2440);
    };

    const throttle = (func, delay) => {
        let lastCall = 0;
        return function (...args) {
            const now = Date.now();
            if (now - lastCall < delay) return;
            lastCall = now;
            func.apply(this, args);
        };
    };

    window.addEventListener('resize', throttle(resizer, 50));
    resizer();

    // select region switch
    document.querySelectorAll('select[data-listener="swap"]').forEach(select => select.addEventListener('change', (event) => {
        window.location = event.target.value;
    }));

};